import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../components/lib/UI/loadingSpinner/LoadingSpinner';
import { useStoreActions } from 'actions/store-actions';
import { useAppSelector } from 'setup/store';
import UITable, { DisplayItem, RowItem } from 'components/lib/UI/table/UITable';
import { IPageData } from 'common/interfaces';
import { IStore } from 'common/interfaces/istore';
import { useEffect, useState } from 'react';
import AccessKeys from 'common/constants/acces';
import { useAccessActions } from 'actions/access-actions';
import ErrorBox from 'components/lib/error-box';
import SearchInput from 'components/lib/search-input/SearchInput';
import { Box, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import AddCircleIcon from '@mui/icons-material/AddCircle';

const headers: DisplayItem[] = [
  {
    label: '#',
  },
  {
    label: 'Name',
  },
  {
    label: 'Store Number',
  },
  {
    label: 'Zip',
  },
  { label: 'Franchisee' },
  { label: '' },
];

const StoresPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const stores = useAppSelector((store) => store.storeReducer.stores);
  const loading = useAppSelector((store) => store.storeReducer.loading);
  const error = useAppSelector((store) => store.storeReducer.error);
  const appConfig = useAppSelector((state) => state.appReducer.appConfig);
  const { hasAccess } = useAccessActions();

  const { loadAllStores, searchStores, deleteStore } = useStoreActions();

  const [_stores, setStores] = useState<IPageData<IStore>>();
  const [searchText, setSearchText] = useState<string>('');
  const [storeToDelete, setStoreToDelete] = useState<IStore | undefined>();
  const canManageStore = hasAccess(AccessKeys.MANAGE_STORE);

  const keyExtractor = (item: IStore, index: number) => {
    return (item.id || index).toString();
  };

  useEffect(() => {
    if (searchText && searchText?.length > 0) {
      _searchStores(searchText, 1, appConfig.defaultListSize);
    } else {
      setStores(stores || ({} as IPageData<IStore>));
    }
  }, [stores]);

  useEffect(() => {
    console.log('Mounted storeScreen.....', stores);
    // loadAllStores(1, config.defaultListSize);
  }, [appConfig]);

  useEffect(() => {
    console.log('Mounted storeScreen.....1', stores);
    loadAllStores(1, appConfig.defaultListSize);
  }, []);

  // const searchstores = (text: string) => {
  //   text = text.toLowerCase();
  //   const filtered = stores?.items?.filter((str) => str.storeName.toLowerCase().indexOf(text) >= 0);
  //   console.log('filtered:::>>>>>>>>>', filtered);
  //   setStores(
  //     filtered && filtered?.length > 0
  //       ? ({
  //           items: filtered,
  //           currentPage: 1,
  //           totalItems: filtered?.length || 0,
  //         } as IPageData<IStore>)
  //       : undefined,
  //   );
  // };
  const _searchStores = async (text: string, pageNo: number, pageSize: number) => {
    console.log('_onSearchTermChange:::', text);
    setSearchText(text || '');
    if (text && text?.length > 0) {
      const resp = await searchStores(
        {
          term: text,
        },
        pageNo,
        pageSize,
      );
      if (resp && resp?.totalItems > 0) {
        setStores(resp);
        return resp;
      } else {
        setStores({} as IPageData<IStore>);
      }
    } else if (!text) {
      setStores(stores || ({} as IPageData<IStore>));
    }
  };

  const _onSearchTermChange = (text?: string) => {
    console.log('_onSearchTermChange:::', text);
    setSearchText(text || '');
    if (text && text?.length > 0) {
      _searchStores(text, 1, appConfig.defaultListSize);
    } else if (!text) {
      setStores(stores || ({} as IPageData<IStore>));
    }
  };
  function _fetchMoreData(pageNo: number, pageSize: number): Promise<IPageData<IStore> | undefined> {
    console.log('_fetchMoreData:::', pageNo, pageSize);
    return loadAllStores(pageNo, pageSize);
  }

  const _onItemPressed = (id?: number) => {
    console.log('_onItemPressed:::', id);
    const store = stores?.items?.find((str) => str.id === id);
    //navigate to add store.
  };

  const _onEditPressed = (id?: number) => {
    console.log('_onEditPressed:::', id);
    const store = stores?.items?.find((str) => str.id === id);
    //navigate to add store.
  };

  const _onDeletePressed = (id?: number) => {
    console.log('_onDeletePressed:::', id);
    const store = stores?.items?.find((str) => str.id === id);
    setStoreToDelete(store);
  };

  const _renderRow = (item: IStore, index: number): RowItem => {
    return {
      id: item.id,
      index,
      data: [
        {
          label: index + 1 + '',
        },
        {
          label: item.storeName,
        },
        {
          label: item.storeNumber + '',
        },
        {
          label: (item.zipcode || '-') + '',
        },
        {
          label: (item.franchiseeAdminName || '-') + '',
        },
      ],
    };
  };

  const _handleItemPressed = (item: IStore) => {
    navigate('/stores/' + item.id);
  };

  return (
    <section>
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={2} className="pageTitleTitleContainer">
        <h2 className="pageTitle">{t('page.stores')}</h2>
        {canManageStore ? (
          <Link to={'/stores/add-new'}>
            <Button variant="contained">
              <AddCircleIcon /> &nbsp;Add New
            </Button>
          </Link>
        ) : null}
      </Box>
      {error ? <ErrorBox title="Error" message={error.msg} /> : null}
      <SearchInput onTextChanged={_onSearchTermChange} placeholder="Search Stores" />
      {_stores ? (
        <UITable
          isLoading={loading}
          pagedData={_stores}
          keyExtractor={keyExtractor}
          pageSize={appConfig.defaultListSize}
          loadData={_fetchMoreData}
          extractRowItem={_renderRow}
          headers={headers}
          onItemPressed={_handleItemPressed}
        />
      ) : null}
    </section>
  );
};

export default StoresPage;
